import RemoteInfoTipMui from './RemoteInfoTipMui'
export * from './RemoteInfoTipMui'
export default RemoteInfoTipMui
